var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisclaimer = function SvgDisclaimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.192 8.692v-1.5h8.616v1.5zm0 2.885v-1.5h8.616v1.5zm2.731 9.923H6q-1.048 0-1.774-.726A2.41 2.41 0 0 1 3.5 19v-2.884h3V2.5h14v8.458a3.26 3.26 0 0 0-1.5.273V4H8v12.116h5.673l-1.5 1.5H5V19q0 .424.287.712Q5.576 20 6 20h5.923zm2.193 0v-2.642l5.428-5.404q.188-.187.404-.263.218-.075.435-.075.232 0 .454.088t.4.265l.925.935q.16.186.25.404.088.218.088.434 0 .217-.08.442-.082.226-.259.412L16.759 21.5zm1.192-1.192h.95l3.246-3.262-.46-.475-.465-.469-3.271 3.256zm3.736-3.737-.465-.469.925.944z"
  })));
};
export default SvgDisclaimer;